import { applyGroupEventsByTimeGapRules } from './applyGroupEventsByTimeGapRules';
import { applyScheduleDisplayRules } from './applyScheduleDisplayRules';
import { collectPrescriptionDateTimeEvents } from './collectPrescriptionDateTimeEvents';

/**
 * Transforms an array of prescription schedules into a flattened load schedule array.
 * Each prescription is expanded into multiple execution events via the execute function.
 * The resulting array contains unique keys and UI flags for rendering.
 *
 * @param {Array} prescriptionSchedulesArray - Array of prescription schedule objects (filtered by padVisitId)
 * @param {Object} pad - PAD data needed for the execute function
 * @param {Array} existingSchedule - Existing schedule to preserve keys from
 * @returns {Array} Transformed schedule data with unique keys and UI flags
 *
 * @example
 * const transformed = transformPrescriptionScheduleToLoadSchedule(
 *   [{ id: 1, frequency: 'DAILY', ... }],
 *   { padId: 123, ... },
 *   existingSchedule
 * );
 * // Returns: [{ key: 'a123', date: '2025-01-15', time: '08:00', ... }, ...]
 */
export const transformPrescriptionScheduleToLoadSchedule = (
  prescriptionSchedulesArray,
  padVisit
) => {
  if (!Array.isArray(prescriptionSchedulesArray) || prescriptionSchedulesArray.length === 0) {
    return [];
  }

  const { totalAmount, maxTimeDifferenceMinutes } = padVisit;

  // 1. Coleta e executa as prescrições
  const allDateTimePrescriptionEvents = collectPrescriptionDateTimeEvents(
    prescriptionSchedulesArray,
    padVisit
  );
  // Ajuste para calculo de frequencia
  // prescriptionSchedulesArray
  //   .filter(presc => presc.padVisitId === padVisitId)
  //   .forEach(padPrescription => {
  //     const { id: padPrescriptionId, prescriptionCalendarEvents } = padPrescription;
  //
  //     const dateTimeEvents = Array.isArray(prescriptionCalendarEvents)
  //       ? prescriptionCalendarEvents
  //       : [];
  //
  //     dateTimeEvents.forEach(dtEvent => {
  //       allDateTimePrescriptionEvents.push({ ...dtEvent, padPrescriptionId, padPrescription });
  //     });
  //   });

  // 2. Agrupa os eventos pelo gap de tempo
  const scheduleMap = applyGroupEventsByTimeGapRules(
    allDateTimePrescriptionEvents,
    maxTimeDifferenceMinutes
  );

  const scheduleList = Array.from(scheduleMap.values());

  // 3. Aplica as regras de negócio de exibição/limites e retorna
  const transformedSchedule = applyScheduleDisplayRules(scheduleList, totalAmount);

  return transformedSchedule;
};
